// UploadList.tsx - PATCHED
import { motion, AnimatePresence } from 'framer-motion';
import UploadContainer from './TuneUploadContainer/TuneUploadContainer.tsx';
import { Dayjs } from 'dayjs';

interface UploadContainerData {
  id: number;
  title: string;
  description: string;
  tags: string[];
  category: string;
  playlistId: string | null;
  privacyStatus: string;
  license: string;
  madeForKids: string;
  image: File | null;
  audio: File | null;
  uploadDate: Dayjs | null;
  isScheduled: boolean;
  imageResize?: {
    enabled: boolean;
    horizontal_offset?: number;
    vertical_offset?: number;
  } | null;
  disableWatermark?: string;
}

interface UploadListProps {
  uploadContainers: UploadContainerData[];
  onUpdate: (index: number, updatedValues: Partial<UploadContainerData>) => void;
  onRemove: (index: number) => void;
  errorsList?: any[];
  resetSignal: number;
}

function UploadList({ uploadContainers, onUpdate, onRemove, errorsList = [], resetSignal }: UploadListProps) {
  const canDelete = uploadContainers.length > 1;
  
  return (
    <div style={{ overflow: 'hidden', width: '100%' }}>
      <AnimatePresence mode="popLayout">
        {uploadContainers.map((container, index) => (
          <motion.div
            key={container.id}
            layout
            initial={{ opacity: 0, y: -20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.9 }}
            transition={{
              layout: { type: "spring", stiffness: 300, damping: 30 },
              opacity: { duration: 0.25 },
              y: { type: "spring", stiffness: 300, damping: 25 },
              scale: { duration: 0.2 }
            }}
            style={{ width: '100%' }}
          >
          <UploadContainer
            containerIndex={index}
            trackNumber={index + 1}
            title={container.title}
            description={container.description}
            tags={container.tags}
            category={container.category}
            playlistId={container.playlistId}
            privacyStatus={container.privacyStatus}
            license={container.license}
            madeForKids={container.madeForKids}
            imageResize={container.imageResize || { enabled: true, horizontal_offset: undefined, vertical_offset: undefined }}
            disableWatermark={container.disableWatermark || 'yes'}
            audioFile={container.audio}
            imageFile={container.image}
            uploadDate={container.uploadDate}
            isScheduled={container.isScheduled}
            onChange={(idx, updatedValues) => onUpdate(idx, updatedValues)}
            onDropAudio={(idx, files) => onUpdate(idx, { audio: files[0] })}
            onDropImage={(idx, files) => onUpdate(idx, { image: files[0] })}
            onUploadDateChange={(idx, date) => onUpdate(idx, { uploadDate: date })}
            onIsScheduledChange={(idx, value) => onUpdate(idx, { isScheduled: value })}
            onRemove={onRemove}
            errors={errorsList[index] || {}}
            resetSignal={resetSignal}
            canDelete={canDelete}
          />
        </motion.div>
      ))}
      </AnimatePresence>
    </div>
  );
}

export default UploadList;
